"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Layout = require("../Layout");

var _Stats = require("./Stats.style");

var Stats = function Stats(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      list = _ref.list,
      button = _ref.button,
      itemsPerRow = _ref.itemsPerRow,
      id = _ref.id;
  var desktopWidth = [4, 6].includes(itemsPerRow) ? 12 / itemsPerRow : 4;
  return /*#__PURE__*/_react.default.createElement(_Layout.Container, {
    id: id
  }, title && /*#__PURE__*/_react.default.createElement(_Stats.Title, null, title), subtitle && /*#__PURE__*/_react.default.createElement(_Stats.Subtitle, null, subtitle), /*#__PURE__*/_react.default.createElement(_Stats.StatsList, null, list && list.map(function (item, key) {
    return /*#__PURE__*/_react.default.createElement(_Layout.Column, {
      width: [12, 6, 6, desktopWidth] // eslint-disable-next-line react/no-array-index-key
      ,
      key: "".concat(item.itemTitle, "_").concat(key)
    }, /*#__PURE__*/_react.default.createElement(_Stats.StatsItem, null, /*#__PURE__*/_react.default.createElement(_Stats.StatsItemTitle, null, item.itemTitle), /*#__PURE__*/_react.default.createElement(_Stats.StatsItemSubtitle, null, item.itemSubtitle)));
  })), button && /*#__PURE__*/_react.default.createElement(_Stats.StatsButton, button, button.label));
};

Stats.propTypes = {
  id: _propTypes.default.string,
  button: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  }),
  itemsPerRow: _propTypes.default.oneOf([4, 6]),
  list: _propTypes.default.arrayOf(_propTypes.default.shape({
    itemTitle: _propTypes.default.string,
    itemSubtitle: _propTypes.default.string
  })),
  subtitle: _propTypes.default.string,
  title: _propTypes.default.string
};
Stats.defaultProps = {
  id: '',
  button: null,
  itemsPerRow: 4,
  list: null,
  subtitle: '',
  title: ''
};
var _default = Stats;
exports.default = _default;